import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title_in: 'Crani - Container In',
    title_in_form: 'Crani - Form Container In',
    breadcrumb_in: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Crani',
        href: '/opc/eir/container-in',
        active: true,
      },
    ],
    title_out: 'Crani - Container Out',
    breadcrumb_out: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Crani',
        href: '/opc/eir/container-out',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    items_out: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    filter: null,
    filterOn: [],
    sortBy: 'id_eir',
    sortDesc: true,
    fields_in: [
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'location_cont',
        label: 'Location',
      },
      {
        key: 'admin_crani',
        label: 'Admin',
      },
      {
        key: 'aksi',
      },
    ],
    fields_out: [
      {
        key: 'code_eir',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'created_at',
        label: 'Date Out',
        sortable: true,
      },
      {
        key: 'admin_crani',
        label: 'Admin',
      },
      {
        key: 'aksi',
      },
    ],
    form: {
      code: '',
      name: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      free_storage: '',
      add_storage: '',
      min_storage: '',
      max_storage: '',
    },
    detail: {
      location: '',
      photo_survey: [],
    },
    company: {},
    items_location: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  detail(state) {
    return state.data.detail;
  },
};

export const mutations = {
  changeEir(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async uploadImageSurvey({ commit, state }, payload) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      let photo_survey = data.detail.photo_survey || [];
      photo_survey.push(result.data.object);

      commit('changeEir', {
        detail: {
          ...data.detail,
          photo_survey,
        },
      });
    }
  },

  async getDownloadFiles({ commit }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    let result = await ApiPostRequest('opr/download', {
      ...payload,
    });

    commit('changeEir', {
      loading: false,
    });
    if (result) {
      return result.data.object;
    }
  },

  async getListEirIn({ commit, state }) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`opr/eir-in`, params);
    commit('changeEir', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListEirOut({ commit, state }) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/eir-out`, params);
    commit('changeEir', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getSearchContainer({ commit }, payload = null) {
    commit('changeEir', {
      loading: true,
      detail: false,
    });

    let result = await ApiGetRequest(`opr/eir-in/search`, payload);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      let data_detail = result.data.object || {};
      if (data_detail.nopol && data_detail.nopol !== '') {
        data_detail.disabled_nopol = true;
      }

      if (data_detail.driver && data_detail.driver.replace(/ /g, '') !== '') {
        data_detail.disabled_driver = true;
      }

      if (!data_detail.location) {
        data_detail.location = '';
      }

      commit('changeEir', {
        detail: data_detail,
      });
    }

    return !result.error ? true : false;
  },

  async getSearchContainerOut({ commit }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/eir-out/search`, payload);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      let data_detail = result.data.object || {};
      data_detail.photo_survey = [];
      if (data_detail.nopol && data_detail.nopol !== '') {
        data_detail.disabled_nopol = true;
      }

      if (data_detail.driver && data_detail.driver.replace(/ /g, '') !== '') {
        data_detail.disabled_driver = true;
      }

      if (!data_detail.location) {
        data_detail.location = '';
      }

      commit('changeEir', {
        detail: data_detail,
      });
    }

    return !result.error ? true : false;
  },

  async searchLocationCont({ commit }, payload = null) {
    let result = await ApiGetRequest(`opr/container/location`, payload);
    if (!result.error) {
      commit('changeEir', {
        items_location: result.data.object || [],
      });

      return result.data.object;
    }

    return false;
  },

  async createEirIn({ commit, state, dispatch }) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/eir-in`, data.detail);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEir', {
        detail: {
          location: '',
        },
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async createEirOut({ commit, state, dispatch }) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/eir-out`, data.detail);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEir', {
        detail: {
          location: '',
        },
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async updateEirIn({ commit, state, dispatch }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`opr/eir-in/${payload.id}`, data.detail);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEir', {
        detail: {
          location: '',
        },
        company: {},
        user: {},
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async updateEirOut({ commit, state, dispatch }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`opr/eir-out/${payload.id}`, data.detail);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEir', {
        detail: {
          location: '',
        },
        company: {},
        user: {},
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async deleteEirIn({ commit, dispatch }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/eir-in/${payload.id}`);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEir', {
        detail: {
          location: '',
        },
        company: {},
        user: {},
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async deleteEirOut({ commit, dispatch }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/eir-out/${payload.id}`);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEir', {
        detail: {
          location: '',
        },
        company: {},
        user: {},
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async getBase64Image(contnext, url) {
    console.log('run here ...');
    const data = await ApiGetRequest(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  },

  async getDetailEir({ commit }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/eir-in/${payload.id}`);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      let data = result.data.object || {};
      commit('changeEir', {
        detail: data.detail,
        company: data.company,
        user: data.user,
      });

      return true;
    }

    return !result.error ? true : false;
  },

  async getDetailEirOut({ commit }, payload = null) {
    commit('changeEir', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/eir-out/${payload.id}`);
    commit('changeEir', {
      loading: false,
    });

    if (!result.error) {
      let data = result.data.object || {};
      commit('changeEir', {
        detail: data.detail,
        company: data.company,
        user: data.user,
      });

      return true;
    }

    return !result.error ? true : false;
  },
};
